var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTitleInclusions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2707_18455)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6667 14.2976H20V16.7466H17.7778V14.5425C17 14.5425 16.2222 14.2976 15.5556 14.0527V21.6446H6.66667V4.50171H11.2222C11.4444 3.64457 11.8889 2.78743 12.3333 2.05273H1.11111C0.555556 2.05273 0 2.54253 0 3.27722V22.8691C0 23.4813 0.444444 24.0936 1.11111 24.0936H21.1111C21.6667 24.0936 22.2222 23.6038 22.2222 22.8691V12.9507C21.4444 13.5629 20.5556 14.0527 19.6667 14.2976ZM4.44444 21.6446H2.22222V19.1956H4.44444V21.6446ZM4.44444 16.7466H2.22222V14.2976H4.44444V16.7466ZM4.44444 11.8487H2.22222V9.39967H4.44444V11.8487ZM4.44444 6.95069H2.22222V4.50171H4.44444V6.95069ZM20 21.6446H17.7778V19.1956H20V21.6446Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 13.3182C14.6667 13.3182 12 10.3795 12 6.706C12 3.03253 14.6667 0.09375 18 0.09375C21.3333 0.09375 24 3.03253 24 6.706C24 10.3795 21.3333 13.3182 18 13.3182ZM18 11.9713C20.6667 11.9713 22.7778 9.64477 22.7778 6.706C22.7778 3.76722 20.6667 1.44069 18 1.44069C15.3333 1.44069 13.2222 3.76722 13.2222 6.706C13.2222 9.64477 15.3333 11.9713 18 11.9713ZM17.3333 9.39987L14.7778 6.58355L15.6667 5.60395L17.3333 7.44069L20.7778 3.76722L21.6667 4.74681L17.3333 9.39987Z",
    fill: "#FAFAFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2707_18455"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.09375)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitleInclusions);
export default __webpack_public_path__ + "static/media/Title-Inclusions.995c472fb1617c592bb5b08cdf0a391d.svg";
export { ForwardRef as ReactComponent };